import { useCallback, useEffect } from "react";

import { useQuery, useQueryClient } from "@tanstack/react-query";
import { SearchStatusResponse, SearchStatusSingleFileRequest } from "generated-types";
import { KB_SOURCE } from "util/constants";

import { baseGetBlobsQueryKey } from "./useGetBlobsQuery";
import axios from "@/configs/axios";

export const baseSearchStatusQueryKey = ["searchStatus"];
export const usePostSearchStatus = (
  payload: SearchStatusSingleFileRequest[] | null,
  enabled: boolean = false
) => {
  const queryClient = useQueryClient();

  const fetchStatus = useCallback(async () => {
    const url = `${process.env.REACT_APP_SERVER_HOST}/search/status`;
    const { data } = await axios.post<SearchStatusResponse>(
      url,
      { files: payload, source: KB_SOURCE },
      {
        headers: {
          "Cache-Control": "no-store",
        },
      }
    );
    return data;
  }, [payload]);

  const { data } = useQuery({
    queryKey: baseSearchStatusQueryKey,
    queryFn: fetchStatus,
    refetchInterval: ({ state }) => {
      if (state?.data?.files.some((file) => file.status === "IN_PROGRESS")) {
        return 10000;
      } else {
        return false;
      }
    },
    enabled,
  });

  useEffect(() => {
    if (!data) return;

    if (data?.files.some((file) => file.status !== "IN_PROGRESS")) {
      queryClient.invalidateQueries({ queryKey: baseGetBlobsQueryKey });
    }
  }, [data]);
};
